import React from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="payment-cancel">
      <div className="soft-card p-10 max-w-md text-center">
        <div className="w-14 h-14 mx-auto rounded-full bg-[#F5F2EC] flex items-center justify-center">
          <X className="w-6 h-6 text-[#8A8D98]" />
        </div>
        <h1 className="font-display text-3xl tracking-tight mt-4">No worries — checkout closed.</h1>
        <p className="text-[#5b5f6e] mt-2">You can upgrade any time. Your practice is still yours.</p>
        <div className="mt-6 flex items-center justify-center gap-3">
          <Link to="/app/premium" className="pill-btn bg-[#E07A5F] text-white hover:bg-[#D26A4F]">Try again</Link>
          <Link to="/app" className="pill-btn border border-[#E5E3DF] text-[#2D3142]">Back to app</Link>
        </div>
      </div>
    </div>
  );
}
